import { render, staticRenderFns } from "./BaseTopicWithChildren.vue?vue&type=template&id=61c1aba0&"
import script from "./BaseTopicWithChildren.vue?vue&type=script&lang=js&"
export * from "./BaseTopicWithChildren.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61c1aba0')) {
      api.createRecord('61c1aba0', component.options)
    } else {
      api.reload('61c1aba0', component.options)
    }
    module.hot.accept("./BaseTopicWithChildren.vue?vue&type=template&id=61c1aba0&", function () {
      api.rerender('61c1aba0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseTopicWithChildren.vue"
export default component.exports